// extracted by mini-css-extract-plugin
module.exports = {"widget-item":"selector_widget-item__15M0J","widget-item-status":"selector_widget-item-status__NOWn1","widget-selector-container":"selector_widget-selector-container__1y-Bx"};